import { render } from "./ContentPlay.vue?vue&type=template&id=44d6e4ca"
import script from "./ContentPlay.vue?vue&type=script&lang=js"
export * from "./ContentPlay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__